import { makeStyles } from '@material-ui/core/styles';

const styles = {
  button: {
    margin: '1rem 0',
  },
};

const useStyles = makeStyles(styles);

export default useStyles;
